import type { FieldDefinition } from "../../lib/types";

export interface StarterTemplate {
  id: string;
  label: string;
  description: string;
  fields: FieldDefinition[];
  workflow?: {
    field: string;
    initial_state: string;
    states: Array<{ name: string }>;
  };
}

export const starterTemplates: StarterTemplate[] = [
  {
    id: "empty",
    label: "Empty",
    description: "A single name field. Add more fields via Claude.",
    fields: [
      { name: "name", type: "text", required: true, display_field: true, display_role: "title" },
    ],
  },
  {
    id: "tracker",
    label: "Tracker",
    description: "Name, status, and notes with a simple workflow.",
    fields: [
      { name: "name", type: "text", required: true, display_field: true, display_role: "title" },
      { name: "status", type: "enum", choices: ["open", "in_progress", "done"] },
      { name: "notes", type: "richtext" },
    ],
    workflow: {
      field: "status",
      initial_state: "open",
      states: [{ name: "open" }, { name: "in_progress" }, { name: "done" }],
    },
  },
  {
    id: "contacts",
    label: "Contacts",
    description: "Name, email, phone, company, and notes.",
    fields: [
      { name: "name", type: "text", required: true, display_field: true, display_role: "title" },
      { name: "email", type: "email" },
      { name: "phone", type: "phone" },
      { name: "company", type: "text" },
      { name: "notes", type: "richtext" },
    ],
  },
  {
    id: "deals",
    label: "Deals",
    description: "Name, stage, amount, close date, and notes with a pipeline workflow.",
    fields: [
      { name: "name", type: "text", required: true, display_field: true, display_role: "title" },
      { name: "stage", type: "enum", choices: ["discovery", "proposal", "negotiation", "closed_won", "closed_lost"] },
      { name: "amount", type: "currency", aggregate: "sum", format: "compact_number" },
      { name: "close_date", type: "date" },
      { name: "notes", type: "richtext" },
    ],
    workflow: {
      field: "stage",
      initial_state: "discovery",
      states: [
        { name: "discovery" },
        { name: "proposal" },
        { name: "negotiation" },
        { name: "closed_won" },
        { name: "closed_lost" },
      ],
    },
  },
];
